import "choices.js/public/assets/styles/choices.css";
import * as Choices from "choices.js";

import { each, on } from "../common/polyfill.js";

const getStorageObj = key => {
  const blob = localStorage.getItem(key);
  if (!blob) {
    return null;
  }

  return JSON.parse(blob);
};

const setStorageObj = (key, obj) => {
  const blob = JSON.stringify(obj);
  localStorage.setItem(key, blob);
};

const favesStorage = new class {
  constructor() {
    this.favesKey = "favorite-orgs";
    this.favesObj = getStorageObj(this.favesKey) || {};
    // Listens for changes by other tabs.
    window.addEventListener("storage", () => {
      this.favesObj = getStorageObj(this.favesKey) || {};
    });
  }

  add(orgID) {
    this.favesObj[orgID] = true;
    setStorageObj(this.favesKey, this.favesObj);
  }

  has(orgID) {
    return this.favesObj[orgID] || false;
  }

  remove(orgID) {
    delete this.favesObj[orgID];
    setStorageObj(this.favesKey, this.favesObj);
  }

  toggle(orgID) {
    if (this.has(orgID)) {
      this.remove(orgID);
    } else {
      this.add(orgID);
    }
  }

  get faves() {
    let keys = Object.keys(this.favesObj);
    keys.sort(id => names[id]);
    return keys;
  }
}();

let checkboxes = document.querySelectorAll("a[data-save-id]");

const updateCheckboxes = () => {
  each(checkboxes, el => {
    let id = el.getAttribute("data-save-id");
    if (favesStorage.has(id)) {
      // Testing to prevent rendering flash
      if (el.classList.contains("has-add")) {
        el.classList.replace("has-add", "has-remove");
        el.innerHTML = `<span class="icon has-text-dark"><i class="fas fa-star"></i></span>`;
      }
    } else {
      if (el.classList.contains("has-remove")) {
        el.classList.replace("has-check", "has-add");
        el.innerHTML = `<span class="icon has-text-dark"><i class="far fa-star"></i></span>`;
      }
    }
  });
};

let statuses = JSON.parse(document.getElementById("status-lists").textContent);
let names = JSON.parse(document.getElementById("org-name").textContent);
let favesDisplay = document.getElementById("faves-display");

const escape = text => {
  let escaper = document.createElement("span");
  escaper.textContent = text;
  return escaper.innerHTML;
};

const renderFaves = (faves, names, statuses) => {
  if (!faves.length) {
    return "";
  }
  let root = document.createElement("div");
  root.innerHTML = `
    <section class="section">
      <div class="container">
        <div class="columns is-multiline">
        </div>
      </div>
    </section>
  `;
  let innerEl = root.querySelector(".columns");
  faves.forEach(faveID => {
    let faveInfos = statuses[faveID];
    let name = names[faveID];

    let messageContainerEl = document.createElement("div");
    messageContainerEl.classList.add("column", "is-half");
    messageContainerEl.innerHTML = `
      <article class="message" data-save-id="${escape(faveID)}">
        <div class="message-header">
          <p>${escape(name)}</p>
          <label class="fav-delete">
            Unfavorite
            <button class="delete" data-save-id="${escape(faveID)}"></button>
          </label>
        </div>
        <div class="message-body">
        </div>
      </article>`;
    innerEl.append(messageContainerEl);

    let messageEl = messageContainerEl.querySelector(".message-body");
    let articleStatus = null;

    if (!faveInfos || !faveInfos.length) {
      messageEl.innerHTML = `
        <p>
          No updates on
          <strong>${escape(name)}</strong>
           have been reported at this time.
        </p>`;
    } else {
      articleStatus = faveInfos[0].status;
      faveInfos.forEach(faveInfo => {
        if (faveInfo.link) {
          messageEl.insertAdjacentHTML(
            "beforeend",
            `
              <p>
                <strong>${escape(faveInfo.date)}</strong>:
                <a
                  href="${encodeURI(faveInfo.link)}"
                  target="_blank"
                >${escape(faveInfo.statusVerbose)}.
                ${escape(faveInfo.extendedStatus)}</a>
              </p>`
          );
        } else {
          messageEl.insertAdjacentHTML(
            "beforeend",
            `
              <p>
                <strong>${escape(faveInfo.date)}</strong>:
                ${escape(faveInfo.statusVerbose)}.
                ${escape(faveInfo.extendedStatus)}
              </p>`
          );
        }
      });
    }
    messageContainerEl
      .querySelector("article")
      .classList.add(cssClassFor(articleStatus));
  });
  return root.innerHTML;
};

const cssClassFor = status => {
  return (
    {
      closed: "is-danger",
      normal: "is-success",
      other: "is-info",
      "change-both": "is-warning",
      "change-early": "is-warning",
      "change-delayed": "is-warning"
    }[status] || "is-success"
  );
};

const updateFaves = () => {
  favesDisplay.innerHTML = renderFaves(favesStorage.faves, names, statuses);
  on(
    "click",
    favesDisplay.querySelectorAll("button[data-save-id]"),
    clickToggle
  );
};

const render = () => {
  updateCheckboxes();
  updateFaves();
};

const clickToggle = event => {
  let id = event.currentTarget.getAttribute("data-save-id");
  favesStorage.toggle(id);
  render();
};

each(".select-js select", el => {
  new Choices(el, {
    itemSelectText: "♡",
    fuseOptions: {
      shouldSort: true,
      tokenize: true,
      matchAllTokens: true,
      includeScore: true
    }
  });
});

on("choice", ".select-js select", e => {
  let id = e.detail.choice.value;
  if (id) {
    favesStorage.add(id);
    render();

    // Scroll down to the item
    let targetEl = document.querySelector(`article[data-save-id="${id}"]`);
    targetEl.scrollIntoView(false);
  }
});

on("click", checkboxes, clickToggle);

render();
